import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Avatar } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Search as SearchIcon, Crown, Rocket } from "lucide-react";

export default function SearchPage() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/users/search", { params: { q } }).then((r) => setResults(r.data)).catch(() => setResults([]));
    }, 300);
    return () => clearTimeout(t);
  }, [q]);

  const now = new Date().toISOString();
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2"><SearchIcon className="w-6 h-6 text-jixxeo-green" /><h2 className="font-head font-extrabold text-xl">Find Hunters</h2></div>
      <Input autoFocus placeholder="Search by name or username…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="search-input" className="bg-white/5 border-white/10 rounded-xl h-12" />
      <div className="space-y-2">
        {results.map((u) => {
          const boosted = u.profile_boost_until && u.profile_boost_until > now;
          return (
            <button key={u.id} onClick={() => navigate(`/profile/${u.id}`)} data-testid={`search-result-${u.id}`}
              className={`w-full glass rounded-2xl p-3 flex items-center gap-3 hover:scale-[1.01] transition-transform ${boosted ? "border border-jixxeo-purple/40" : ""}`}>
              <Avatar user={u} size={44} />
              <div className="flex-1 min-w-0 text-left">
                <p className="font-bold text-sm truncate flex items-center gap-1">{u.name}{u.elite && <Crown className="w-3.5 h-3.5 text-jixxeo-purple" />}{boosted && <Rocket className="w-3 h-3 text-jixxeo-purple" />}</p>
                <p className="text-xs text-muted-foreground">@{u.username} · {u.rank}</p>
              </div>
              <span className="text-xs text-muted-foreground">{u.followers} followers</span>
            </button>
          );
        })}
        {q && results.length === 0 && <p className="text-center text-muted-foreground py-6 text-sm">No hunters found.</p>}
      </div>
    </div>
  );
}
